import { render } from "./cg.vue?vue&type=template&id=458711cd&scoped=true&ts=true"
import script from "./cg.vue?vue&type=script&lang=ts"
export * from "./cg.vue?vue&type=script&lang=ts"

import "./cg.vue?vue&type=style&index=0&id=458711cd&lang=less&scoped=true"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-458711cd"]])

export default __exports__